<template>
	<h2 class="subtitle is-6 is-aligned-center">
		<dp-svg class="is-small" svg="decoratorLineLeft" />
		<span class="is-inline-block is-decorated">
			<slot>{{ value }}</slot>
		</span>
		<dp-svg class="is-flipped-horizontal is-small" svg="decoratorLineLeft" />
	</h2>
</template>

<script>
export default {
	name: 'DpDecorTitle',
	props: {
		value: { type: String, default: null },
	},
};
</script>
